module.exports = __webpack_public_path__ + "static/media/coupon.539f7b47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/coupon.svg
// module id = 134
// module chunks = 0